'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.classificationById = classificationById;
exports.subClassificationById = subClassificationById;
var hierarchy = require('./classifications-hierachy');

var classifications = {};
var subClassifications = {};

hierarchy.forEach(function (classification) {
  classifications[classification.id] = classification.description;

  classification.subClassifications.forEach(function (subClassification) {
    subClassifications[subClassification.id] = subClassification.description;
  });
});

function classificationById(id) {
  return classifications[id];
}

function subClassificationById(id) {
  return subClassifications[id];
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-classifications-hierarchy/build/lookupById.js
 ** module id = 450
 ** module chunks = 0
 **/